// extracted by mini-css-extract-plugin
module.exports = {"FaQList":"style_FaQList__V4O_0","FaQListButton":"style_FaQListButton__unkvd"};